// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslateButton-cls1_FcA","cls2":"TranslateButton-cls2_V3n TranslateButton-cls1_FcA"};